import styled from 'styled-components';
import { Typography, TypographyProps, TypographyVariant } from '@material-ui/core';
import * as React from 'react';
import { theme } from '../../../utils/theme';
import { Skeleton } from '@material-ui/lab';

export type H1Props = TypographyProps & {
  variant?: TypographyVariant;
}

export const StyledH1 = styled(Typography)((props) => ({
  color: theme(props).palette.common.black,
  fontWeight: 'bold',
  fontSize: '24px',
  lineHeight: '29px',
})) as typeof Typography;

export const H1: React.FC<H1Props> = props => {
  if (props.children) {
    return (<StyledH1 variant="h1" align="left" display="block" noWrap {...props} />);
  }
  return <Skeleton variant="rect" width="35%" height="29px" />;
}